module.exports = __webpack_public_path__ + "media/images/circles-39d7b737de1361db6159ec2f63a9cbf8.png";